import { apiClient } from '../client'
import type { ApiSuccessResponse } from '../../types/api'

export const userService = {
  async resendCredentials(id: string) {
    const { data } = await apiClient.post<ApiSuccessResponse<null>>(
      `/users/${id}/resend-credentials`,
    )
    return data
  },
}
